import { formatName } from "@ca-dmv-radv/utilities";

/**
 * Adapted with minimal change from previous version of app.
 */
export function parseReceivedNameChanges(
  nameChanges,
  application,
  category = "identity"
) {
  const identityDocName = {
    id: 0,
    name: formatName(application.documents[category].documentName),
    firstName: application.documents[category].documentName.firstName || "",
    middleName: application.documents[category].documentName.middleName || "",
    lastName: application.documents[category].documentName.lastName || "",
    suffix: application.documents[category].documentName.suffix || "",
    catDocId: application.documents[category].catDocId,
    order: 0,
  };

  const nextNameChanges = [identityDocName, ...nameChanges];

  if (nameChanges.length === 0) {
    nextNameChanges.push({
      id: null,
      name: formatName(application.application.name),
      firstName: application.application.name.firstName || "",
      middleName: application.application.name.middleName || "",
      lastName: application.application.name.lastName || "",
      suffix: application.application.name.suffix || "",
      catDocId: null,
      order: nameChanges.length + 1,
    });
  }

  return nextNameChanges;
}
